<mat-menu
  #settingsMenu="matMenu"
  yPosition="above"
  xPosition="before"
  class="context-menu">
  <ng-template matMenuContent>
    @if (userData(); as user) {
      <div class="nav__account-info">
        <p class="nav__account-name">
          {{ user.name || ('GNR_LOGGED_IN' | translate) }}
        </p>
        @if (user.company) {
          <p class="nav__account-company">
            {{ user.company }}
          </p>
        }
        @if (user.email) {
          <p class="nav__account-email">{{ user.email }}</p>
        }
      </div>
    }
    <ng-container>
      <a
        mat-menu-item
        [href]="issueReportLink"
        target="_blank"
        rel="noopener noreferrer">
        <mat-icon>bug_report</mat-icon>
        <span>{{ 'GNR_REPORT_ISSUE' | translate }}</span>
      </a>
      <button mat-menu-item (click)="openSettings()">
        <mat-icon>settings</mat-icon>
        <span>{{ 'GNR_SETUP' | translate }}</span>
      </button>
      @if (pwa.canInstall | async) {
        <button mat-menu-item (click)="pwa.prompt()">
          <mat-icon>get_app</mat-icon>
          <span>{{ 'FTR_WZD_ADD_TO_DESKTOP' | translate }}</span>
        </button>
      }
      <mat-divider></mat-divider>
      <a mat-menu-item (click)="handleLogout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{ 'GNR_LOGOUT' | translate }}</span>
      </a>
    </ng-container>
  </ng-template>
</mat-menu>

<div class="nav__avatar-container" fxLayout fxLayoutAlign="start center">
  <button
    mat-icon-button
    class="nav__avatar-button"
    [matMenuTriggerFor]="settingsMenu"
    aria-label="Open menu">
    @if (personalAvatarUrl(); as avatarUrl) {
      <img class="nav__avatar-img" [src]="avatarUrl" alt="Avatar" />
    } @else {
      <mat-icon class="nav__avatar-icon">account_circle</mat-icon>
    }
  </button>
  @if (!isHiddenUserName) {
    <div>
      @if (userData(); as user) {
        <div class="user">
          <h3 class="user__title ellipsis" [matTooltip]="user.name">
            {{ user.name }}
          </h3>
          <small class="user__subtitle ellipsis" [matTooltip]="user.company">{{
            user.company
          }}</small>
        </div>
      }
    </div>
  }
</div>
